import React, { useCallback } from 'react';

import { FaFacebook, FaInstagram, FaLinkedin, FaTwitter } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

import { StyledFooterSocials } from './styles';
import { Paragraph1 } from '../../../../theme';
import googlePlayBadge from '../../../../theme/assets/badges/google-play-badge.png';
import horizontalLogo from '../../../../theme/assets/logo/logo-horizontal.webp';
import { bemClassName } from '../../../../utils/bem';
import { GOOGLE_PLAY_URL } from '../../../../utils/constants';
import { SocialButton } from '../../../atoms/social-button';

const b = bemClassName('footer-socials');

const FooterSocials = () => {
  const navigate = useNavigate();

  const handleGoToHome = useCallback(() => {
    navigate('/');
  }, [navigate]);

  return (
    <StyledFooterSocials>
      <div className={b('logo')}>
        <img src={horizontalLogo} alt="Active Shape" onClick={handleGoToHome} />
      </div>
      <Paragraph1>
        Explore personalized diets and workouts, track your wellness journey, and achieve your goals with our
        comprehensive tools.
      </Paragraph1>
      <div className={b('social-buttons')}>
        <SocialButton link={'https://twitter.com/'} ariaLabel="Follow Active Shape on X (Twitter)">
          <FaTwitter />
        </SocialButton>
        <SocialButton link={'https://linkedin.com/'} ariaLabel="Follow Active Shape on LinkedIn">
          <FaLinkedin />
        </SocialButton>
        <SocialButton link={'https://facebook.com/'} ariaLabel="Follow Active Shape on Facebook">
          <FaFacebook />
        </SocialButton>
        <SocialButton link={'https://instagram.com/'} ariaLabel="Follow Active Shape on Instagram">
          <FaInstagram />
        </SocialButton>
      </div>
      <div className={b('app-badges')}>
        <a
          href={GOOGLE_PLAY_URL}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Get Active Shape on Google Play"
        >
          <img src={googlePlayBadge} alt="Get it on Google Play" />
        </a>
      </div>
    </StyledFooterSocials>
  );
};

export default FooterSocials;
